class UpdModel {
  constructor(type,userid,postid) {
    this.type = type;
    this.userid = userid;
    this.postid = postid;
  }
}
export default UpdModel;
